const GENERIC_ERROR = 'GENERIC_ERROR';
const FORM_ERROR = 'FORM_ERROR';
const MAX_NAME_LENGTH = 200;
const MAX_DESCRIPTION_LENGTH = 150;

const automations_dataAnalytics = {
  input_shipToCountries: 'automations_condition_addRuleForm_input_shipToCountriesConditionValue',
  input_shipToState: 'automations_condition_addRuleForm_input_shipToStatesConditionValue',
  input_shipToZipcode: 'automations_condition_addRuleForm_input_shipToZipcodesConditionValue',
  select_shippingDestType:
    'automations_condition_addRuleForm_select_shippingDestinationConditionValue',
};

const ShippingCountryType = {
  ALL_country: 'ALL_country',
  CA_country: 'CA_country',
  CA_state: 'CA_state',
  CA_zipcode: 'CA_zipcode',
  US_country: 'US_country',
  US_state: 'US_state',
  US_zipcode: 'US_zipcode',
};

enum ConditionFilterType {
  DEFAULT = '',
  IS_INTERNATIONAL = 'IS_INTERNATIONAL',
  ITEM_SKU = 'ITEM_SKU',
  ORDER_ITEM_QUANTITY = 'ORDER_ITEM_QUANTITY',
  PRODUCT_NAME = 'PRODUCT_NAME',
  SHIPPING_COUNTRIES = 'SHIPPING_COUNTRIES',
  SHIPPING_DESTINATION = 'SHIPPING_DESTINATION',
  SHIPPING_STATES = 'SHIPPING_STATES',
  SHIPPING_ZIPCODES = 'SHIPPING_ZIPCODES',
  WEIGHT = 'WEIGHT',
}

enum ActionType {
  ASSIGN_TAG = 'ASSIGN_TAG',
  DEFAULT = '',
  PARCEL_TEMPLATE = 'PARCEL_TEMPLATE',
  SENDER_ADDRESS = 'SENDER_ADDRESS',
  SERVICE_LEVEL = 'SERVICE_LEVEL',
}

type ConditionOptionsType = {
  [ConditionFilterType.DEFAULT]?: string;
  [ConditionFilterType.IS_INTERNATIONAL]?: string;
  [ConditionFilterType.ITEM_SKU]?: string;
  [ConditionFilterType.ORDER_ITEM_QUANTITY]?: string;
  [ConditionFilterType.PRODUCT_NAME]?: string;
  [ConditionFilterType.SHIPPING_COUNTRIES]?: string;
  [ConditionFilterType.SHIPPING_DESTINATION]?: string;
  [ConditionFilterType.SHIPPING_STATES]?: string;
  [ConditionFilterType.SHIPPING_ZIPCODES]?: string;
  [ConditionFilterType.WEIGHT]?: string;
  [ConditionFilterType.WEIGHT]?: string;
};

export {
  ActionType,
  ConditionFilterType,
  ConditionOptionsType,
  FORM_ERROR,
  GENERIC_ERROR,
  MAX_DESCRIPTION_LENGTH,
  MAX_NAME_LENGTH,
  ShippingCountryType,
  automations_dataAnalytics,
};
